function preparePlugins(container)
{

}

function flashMessages()
{
    toastr.options = {
        "closeButton": true,
        "debug": false,
        "newestOnTop": true,
        "progressBar": true,
        "positionClass": "toast-bottom-center",
        "preventDuplicates": true,
        "onclick": null,
        "timeOut": "3500",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
    };

    FLASHESS.forEach(function (v, k) {
        console.log(v.message);
        console.log('hejejejlek');
        toastr[v.type](v.message);
    });

    FLASHESS.length = 0;
}

$(document).ready(function () {

    preparePlugins($(document));
    flashMessages();

    let topLine = $('.top-line');
    let mainMenu = $('#main-menu .menu-wrap');
    let main = $('body');

    if ($(window).scrollTop() > 0) {
        topLine.addClass('fixed');
        setTimeout(function () {
            main.css('padding-top', topLine.outerHeight());
        }, 401);
    }

    $(window).on('scroll resize', function (e) {

        if ($(window).scrollTop() > 0) {
            topLine.addClass('fixed');
            main.css('padding-top', topLine.outerHeight());

            setTimeout(function () {
                main.css('padding-top', topLine.outerHeight());
            }, 401);

        } else {
            setTimeout(function () {
                topLine.removeClass('fixed');
                main.css('padding-top', 0);
            }, 401);
        }

        if (window.matchMedia('(min-width: 1200px)').matches) {
            mainMenu.css({
                'top': 'unset',
                'height': 'unset'
            });
        } else {
            if (mainMenu.hasClass('visible')) {
                mainMenu.css({
                    'top': topLine.outerHeight(),
                    'height': $(window).height() - topLine.outerHeight()
                });
            }
        }

    });

    $(document).on('click', '.navbar .hamburger', function (e) {

        let target = $(this).data("target");

        if (isDefined(target)) {

            target = $(document).find(target);
            $(this).toggleClass('active');

            target.css({
                'top': topLine.outerHeight(),
                'height': $(window).height() - topLine.outerHeight()
            });

            let nowVisible = target.hasClass('visible');

            if (nowVisible) {
                target.removeClass('visible');
            } else {
                target.addClass('visible');
            }

        }

    });

    $.nette.init();

    $.nette.ext({
        complete: function (payload) {
            preparePlugins($("body"));
            flashMessages();
        }
    });

    let swiper = $(document).find('.swiper');
    if(swiper.length > 0){
        const swiper = new Swiper('.swiper', {
            lazy: {
                loadPrevNext: true,        // Načte obrázky před a po aktuálním snímku
                loadPrevNextAmount: 1,     // Počet obrázků načítaných před a po (zvýšit pro lepší UX při rychlém swipování)
                loadOnTransitionStart: false // Načítá obrázky pouze při změně snímku (nezpůsobí předčasné načtení)
            },
            preloadImages: false,        // Deaktivuje standardní preload všech obrázků
            watchSlidesProgress: true,   // Umožní sledování, které snímky jsou viditelné
            watchSlidesVisibility: true,  // Načítá pouze viditelné snímky
            loadPrevNext: false,
            loadPrevNextAmount: 0,
            // Optional parameters
            direction: 'horizontal',
            loop: true,

            // If we need pagination
            pagination: {
                el: '.swiper-pagination',
            },

            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            autoplay: {
                delay: 3500,
                disableOnInteraction: false
            },
        });
    }
});


$(document).on("submit", ".color-variant-form", function (e) {
    e.preventDefault();
    console.log($(this).closest(".addColorVariantButton"));
    $(this).find(".addColorVariantButton")[0].click();
});
$(document).on("submit", ".product-variant-form", function (e) {
    e.preventDefault();
});


function manageDeliveryContainerDropdown() {
    if($("#deliveryDifferent-checkbox").is(':checked')) {
        $("#deliveryContainer").removeClass("d-none");
    } else {
        $("#deliveryContainer").addClass("d-none");
    }
}

$(document).ready(function () {
    let width = Math.min(1, $("#data-holder").data("value") / $("#data-holder").data("full")) * 100;
    $(".delivery-free-counter--indicator").css("width", width + "%");
});

$(document).ajaxComplete(function () {
    let width = Math.min(1, $("#data-holder").data("value") / $("#data-holder").data("full")) * 100;
    $(".delivery-free-counter--indicator").css("width", width + "%");
    manageDeliveryContainerDropdown();
});
manageDeliveryContainerDropdown();

$(document).on("change", "#deliveryDifferent-checkbox", manageDeliveryContainerDropdown);


window.onload = (event) => {
    $(document).on("submit", ".product-variant-form", function (e) {
        e.preventDefault();
    });
};

$(document).on("change", "#input-select", function (e) {
    e.preventDefault();
    sendFormColorVariants($(this), 0);
});


$(document).on("click", ".addColorVariantButton", function (e) {
    e.preventDefault();
    let increment = parseInt($(this).data("increment"));
    sendFormColorVariants($(this), increment);
});

function sendFormColorVariants(_this, increment) {
    let form_data = _this.closest("form").serializeArray();
    let data = [];
    form_data.forEach(function (v) {
        if (v.name !== '_do') {
            if(v.name === 'amount'){
                v.value = parseInt(v.value) + increment;
                if(v.value < 0) {
                    v.value = 0;
                }
            }
            data.push(v);
        }
    });

    let href = _this.data("href");
    $.nette.ajax({
        url: href,
        data: data,
        type: 'POST',
        off: {
            snippets: false
        }
    }).done(function (payload) {
        if (payload.error) {
            toastr.warning(payload.error.message);
        }
        if (payload.info) {
            toastr.info(payload.info.message);
        }
    });
}
